import { FastlyImage } from '@components/common/image'
import Button, { SizeType } from '@components/atoms/button'
import Router from 'next/router'
import { TRUSTPILOT_AFTER_SCHOOL_PROGRAM_RANK } from '@lib/constants/common'

type Props = {
  ctaSize?: SizeType
}

const TrustedByParents = ({ ctaSize }: Props) => (
  <div className="px-5 py-12 lg:py-16 bg-blue-50 bg-opacity-25">
    <div className="container mx-auto relative">
      <FastlyImage
        src="/images/teacher-lp/confetti-bg.png"
        alt="Confetti"
        width={1365}
        height={418}
        objectFit="cover"
        className="absolute z-0"
      />
      {/* Heading */}
      <h2 className="pb-3 text-2xl text-center text-grey lg:text-4xl font-600 max-w-2xl mx-auto relative">
        Trusted by parents. Loved by students. Powered by teachers.
      </h2>

      {/* Body: two-col desktop, stacked mobile */}
      <div className="mt-10 flex flex-col md:flex-row items-center gap-8 relative">
        {/* Left: trust signals */}
        <div className="flex-1 flex flex-col items-center gap-4">
          {/* Trustpilot logo */}
          <div className="flex items-center gap-2">
            <FastlyImage
              src="/images/teacher-lp/trust-pilot-stacked-black.png"
              alt="Trustpilot"
              width={184}
              height={85}
            />
          </div>

          {/* Ranked text */}
          <p className="text-2xl font-700" style={{ color: '#00B67A' }}>
            Ranked in Top #{TRUSTPILOT_AFTER_SCHOOL_PROGRAM_RANK}
          </p>

          {/* Award with laurels */}
          <div className="flex items-center gap-2">
            <div style={{ transform: 'scaleX(-1)' }}>
              <FastlyImage
                src="/images/teacher-lp/leaf-concave.png"
                alt="Leaf"
                width={48}
                height={64}
              />
            </div>
            <p className="text-2xl font-700 text-grey-900 text-center leading-tight">
              Best in
              <br />
              After School Program
            </p>
            <FastlyImage
              src="/images/teacher-lp/leaf-concave.png"
              alt="Leaf"
              width={48}
              height={64}
            />
          </div>
        </div>

        {/* Right: penguin family image */}
        <div className="flex-1 flex justify-center">
          <FastlyImage
            src="/images/teacher-lp/mascot-laptop.png"
            alt="Codingal penguin family"
            width={570}
            height={344}
            className="w-full max-w-md"
          />
        </div>
      </div>

      {/* CTA */}
    </div>
    <div className="flex justify-center mt-8">
      <Button
        variant="outline"
        intent="primary"
        size={ctaSize ?? 'lg'}
        onClick={() => Router.push('/reviews-and-testimonials/')}
        className="w-full sm:w-auto"
      >
        See more reviews
      </Button>
    </div>
  </div>
)

export default TrustedByParents
